import { PaymentMethodApi } from "@app/services/apiServices/PaymentMethodApi";
import { PaymentMethod } from "@app/models/PaymentMethod";
import { UtilService } from "@app/services/Util.service";
import { SpinnerService } from "@app/services/spinner.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { Property } from "@app/models/Property";
import { UserStore } from "@app/services/stores/UserStore";
import { PropertiesService } from '@app/services/properties.service';
import { PropertySelectorService } from '@app/pages/wallet/landing/property-selector.service';
import { take } from "rxjs/operators";
import { Component, Inject } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { Observable } from "rxjs";
import { Router } from "@angular/router";

@Component({
    selector: 'app-wallet-landing',
    template: require('./walletlanding.component.html')
})
export class WalletLandingComponent {
    paymentMethods: PaymentMethod[];
    cardPaymentMethods: PaymentMethod[];
    checkPaymentMethods: PaymentMethod[];
    properties: Property[];
    hasPaymentMethod: boolean;
    apiCalled: boolean;
    doneLoading: boolean;
    comingFromPayNow: boolean;
    property: Property;
    propertyId: any;
    $stateParams: any;

    constructor(@Inject(PaymentMethodApi) private paymentMethodApi: PaymentMethodApi,
                @Inject(UtilService) private utilService: UtilService,
                @Inject(WindowToken) public window,
                @Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(PropertiesService) private propertyService: PropertiesService,
                @Inject(PropertySelectorService) private propertySelectorService: PropertySelectorService,
                @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }

        this.paymentMethods = [];
        this.cardPaymentMethods = [];
        this.checkPaymentMethods = [];
        this.doneLoading = false;
        this.propertySelectorService = propertySelectorService;
        if (this.$stateParams) {
            this.comingFromPayNow = this.$stateParams.comingFromPayNow ? this.$stateParams.comingFromPayNow : false;
            this.propertyId = this.$stateParams.propertyId ? this.$stateParams.propertyId : null;
            this.property = this.$stateParams.property ? this.$stateParams.property : null;
        }

        this.spinnerService.showSpinner();
        if (this.userStore.getHoaHomeownerId()) {
            this.getPaymentMethod().pipe(take(1)).subscribe({
                next: () => {
                    this.spinnerService.closeSpinner();
                    this.doneLoading = true;
                },
                error: () => {
                }
            });
        }

        this.spinnerService.closeSpinner();
    }

    checkAdd() {
        this.router.navigateByUrl('/wallet/checkadd',  { state: {
            comingFromPayNow: this.comingFromPayNow,
            propertyId: this.propertyId,
            property: this.property
        } });
    }

    cardAdd() {

        this.router.navigateByUrl('/wallet/creditcardadd', { state: {
            comingFromPayNow: this.comingFromPayNow,
            propertyId: this.propertyId,
            property: this.property
        } });

    }

    getPaymentMethod() {
        return new Observable(observer => {
            this.paymentMethodApi.homeownersIdPaymentMethodsGet(this.userStore.getHoaHomeownerId())
                .pipe(take(1)).subscribe({
                    next: resp => {
                        this.apiCalled = true;
                        if (resp && resp.length > 0) {
                            this.hasPaymentMethod = true;
                            this.paymentMethods = resp;
                            this.paymentMethods.forEach((paymentMethod: PaymentMethod) => {
                                if (paymentMethod.cardType && paymentMethod.cardBrand) {
                                    this.cardPaymentMethods.push(paymentMethod);
                                } else {
                                    this.checkPaymentMethods.push(paymentMethod);
                                }
                            });
                            if (this.cardPaymentMethods.length > 1) {
                                this.sortPaymentMethods(this.cardPaymentMethods);
                            }
                            if (this.checkPaymentMethods.length > 1) {
                                this.sortPaymentMethods(this.checkPaymentMethods);
                            }
                            observer.next(undefined);
                        } else {
                            this.hasPaymentMethod = false;
                            observer.next(undefined);
                        }
                    },
                    error: err => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                this.apiCalled = true;
                                if (resp === true) {
                                    this.getPaymentMethod();
                                }
                                observer.error();
                            });
                    }
                });
        })
    }

    sortPaymentMethods(paymentArray: PaymentMethod[]){
        paymentArray.sort((x, y) => {
            if(x.defaultMethod === y.defaultMethod) {
                if (x.id > y.id) {
                    return 1;
                } else if (x.id < y.id) {
                    return -1;
                } else {
                    return 0;
                }
            } else if (x.defaultMethod > y.defaultMethod) {
                return -1;
            } else if (x.defaultMethod < y.defaultMethod) {
                return 1;
            }

            return 0;
        })
    }
}

